app.controller("CalendarEventsIndexController", [
    "$scope", "$stateParams", "$uibModal", "$state", "usSpinnerService", "CalendarEventsService", "ConfirmModal", "toastr",
    function ($scope, $stateParams, $uibModal, $state, usSpinnerService, CalendarEventsService, ConfirmModal, toastr) {
        $scope.calendarEvents = null;
        $scope.totalItems = 0;
        $scope.itemsPerPage = 8;
        $scope.title = null;
        $scope.fromDate = $stateParams.fromDate;
        $scope.toDate = $stateParams.toDate;

        $scope.popup1 = {
            opened: false
        };

        $scope.popup2 = {
            opened: false
        };

        $scope.openFromDate = function () {
            $scope.popup1.opened = true;
        };

        $scope.openToDate = function () {
            $scope.popup2.opened = true;
        };

        function loadPage(page, fromDate, toDate, callback) {
            callback = callback || function () {
            };
            usSpinnerService.spin("root");
            CalendarEventsService.list({
                page: page,
                fromDate: fromDate,
                toDate: toDate,
                limit: $scope.itemsPerPage
            }).then(function (data) {
                $scope.calendarEvents = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                callback();
            });
        }

        loadPage($stateParams.page, $scope.fromDate, $scope.toDate, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                fromDate: $scope.fromDate,
                toDate: $scope.toDate
            });
        };

        $scope.open = function (calendarEvent) {
            $uibModal.open({
                controller: "CalendarEventWindowController",
                templateUrl: _pb + 'admin/calendarEvents/calendar-event-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {calendarEvent: calendarEvent};
                    }
                }
            }).result
                .then(function () {
                    loadPage($stateParams.page, $scope.fromDate, $scope.toDate, function () {
                        $scope.currentPage = $stateParams.page;
                    });
                }, function () {
                });
        };

        $scope.add = function () {
            $state.go("admin.calendar-events-add");
        };

        $scope.edit = function (calendarEvent) {
            $state.go("admin.calendar-events-edit", {
                calendarEventId: calendarEvent._id
            });
        };

        $scope.remove = function (calendarEvent) {
            ConfirmModal.show({
                title: "ღონისძიების წაშლა",
                message: "ყურადღება! ნამდვილად გსურთ ღონისძიების წაშლა?"
            }).result.then(function () {
                CalendarEventsService.remove({
                    _id: calendarEvent._id
                }).then(function () {
                    toastr.success('', 'ღონისძიება წარმატებით წაიშალა');
                    loadPage($stateParams.page, $scope.fromDate, $scope.toDate, function () {
                        $scope.currentPage = $stateParams.page;
                    });
                });
            });
        };
    }
]);
